import { injectIntl } from "react-intl";
import { formatNumber } from "src/helpers/formatNumber";

const TABLE_COLUMNS = [
  { key: "name", label: "LIST", align: "left" },
  { key: "revenue", label: "REVENUE", align: "right" },
  { key: "cost", label: "COST", align: "right" },
  { key: "profit", label: "PROFIT", align: "right" },
  { key: "roi", label: "ROI", align: "right" },
  { key: "messages", label: "MESSAGES", align: "right" },
  { key: "campaigns", label: "CAMPAIGNS", align: "right" },
];

const formatMessages = (value) => {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`;
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`;
  }
  return (value ?? 0).toLocaleString();
};

const getRoiColor = (roi) => {
  if (roi < 100) return "#EC4899";
  if (roi <= 300) return "#F59E0B";
  return "#7C3AED";
};

const ListPerformance = ({ data = [] }) => {
  const renderCell = (item, column) => {
    switch (column.key) {
      case "name":
        return (
          <span className="SmsAnalyticsListPerformanceName">{item.name}</span>
        );
      case "revenue":
        return (
          <span className="SmsAnalyticsListPerformanceRevenue">
            ${formatNumber(item.revenue)}
          </span>
        );
      case "cost":
        return (
          <span className="SmsAnalyticsListPerformanceCost">
            ${formatNumber(Math.abs(item.cost ?? 0))}
          </span>
        );
      case "profit":
        return (
          <span className="SmsAnalyticsListPerformanceProfit">
            ${formatNumber(item.profit)}
          </span>
        );
      case "roi":
        return (
          <span
            className="SmsAnalyticsListPerformanceROI"
            style={{ color: getRoiColor(item.roi) }}
          >
            {formatNumber(item.roi)}%
          </span>
        );
      case "messages":
        return (
          <span className="SmsAnalyticsListPerformanceMessages">
            {formatMessages(item.messages)}
          </span>
        );
      case "campaigns":
        return (
          <span className="SmsAnalyticsListPerformanceCampaigns">
            {(item.campaigns ?? 0).toLocaleString()}
          </span>
        );
      default:
        return null;
    }
  };

  return (
    <div className="SmsAnalyticsChartCard SmsAnalyticsChartCardFull">
      <div className="SmsAnalyticsChartTitle">List Performance</div>
      <div className="SmsAnalyticsListPerformanceTable">
        <div className="SmsAnalyticsListPerformanceHeader">
          {TABLE_COLUMNS.map((column) => (
            <div
              key={column.key}
              className={`SmsAnalyticsListPerformanceHeaderCell SmsAnalyticsListPerformanceCell--${column.align}`}
            >
              {column.label}
            </div>
          ))}
        </div>
        {data.map((item) => (
          <div key={item.name} className="SmsAnalyticsListPerformanceRow">
            {TABLE_COLUMNS.map((column) => (
              <div
                key={column.key}
                className={`SmsAnalyticsListPerformanceCell SmsAnalyticsListPerformanceCell--${column.align}`}
              >
                {renderCell(item, column)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default injectIntl(ListPerformance);
